import { Component } from '@angular/core';
import { TimeEntryApprovalComponent } from '../employees/time-entry-approval/time-entry-approval';

@Component({
    selector: 'app-admin-approval-view',
    standalone: true,
    imports: [TimeEntryApprovalComponent],
    template: `<div class="bg-white rounded-2xl border border-gray-200 shadow-sm overflow-hidden"><app-time-entry-approval></app-time-entry-approval></div>`
})
export class AdminApprovalView { }
